module.exports = __webpack_public_path__ + "img/profitAnalysisMiddle@1x.77ee9362.png";